import { render } from "./billList.vue?vue&type=template&id=b674efc0&scoped=true"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"

import "./billList.vue?vue&type=style&index=0&id=b674efc0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b674efc0"]])

export default __exports__